// store.js
import { configureStore } from '@reduxjs/toolkit';
import loaderReducer from './loaderSlice'; // Import your loader slice
import authReducer from './authSlice';
import printRequestsReducer from './printRequestSlice';
const store = configureStore({
  reducer: {
    auth: authReducer,
    loader: loaderReducer, // Add your loader slice reducer here
    printRequests: printRequestsReducer
    // Add other reducers here as needed
  },
});

export default store;
